<template>
  <el-dialog
    class="dialog-container dialog-height"
    :title="title"
    :visible.sync="dialogVisible"
    :width="$i18n.locale == 'zh' || $i18n.locale == 'fa' ? '800px' : '1000px'"
    append-to-body
    destroy-on-close
  >
    <div slot="title" class="header-title">
      <img src="@/assets/image/newIssue.png" alt="" />
      <span>{{ title }}</span>
    </div>
    <el-form
      ref="form"
      :model="form"
      :rules="formRules"
      :label-width="labelWidth"
    >
      <!-- 基本信息 -->
      <div>
        <div class="titleTips">
          <img src="@/assets/image/basicIcon.png" alt="" />
          <span>{{ $t("zlfk.jbxx") }}</span>
        </div>
        <!-- 车型 -->
        <el-form-item :label="$t('home.carType') + ':'" prop="carModel">
          <el-input
            v-model="form.carModel"
            :placeholder="$t('placeholder.enter')"
          />
          <!-- <el-select filterable clearable v-model="form.carModel" @change="getVinList">
          <el-option
            v-for="item in carTypeList"
            :key="item.value"
            :label="item.text"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
        </el-form-item>
        <!-- 车辆属性 -->
        <el-form-item :label="$t('zlfk.clsx') + ':'" prop="carAttribute">
          <el-select v-model="form.carAttribute" filterable clearable>
            <el-option :label="$t('climant.ryc')" :value="0"> </el-option>
            <el-option :label="$t('climant.ddc')" :value="1"> </el-option>
          </el-select>
        </el-form-item>
        <!-- 故障发生日期 -->
        <el-form-item :label="$t('zlfk.gzfsrq') + ':'" prop="happenDate">
          <el-date-picker
            type="date"
            value-format="yyyy-MM-dd"
            v-model="form.happenDate"
            :placeholder="$t('placeholder.select')"
          />
        </el-form-item>
        <!-- 故障发生地点 -->
        <el-form-item :label="$t('zlfk.gzfsdd') + ':'" prop="happenPlace">
          <el-input
            v-model="form.happenPlace"
            maxlength="200"
            :placeholder="$t('placeholder.enter')"
          />
        </el-form-item>
        <!-- 报修日期 -->
        <el-form-item :label="$t('seek.warrantyDate') + ':'" prop="repairDate">
          <el-date-picker
            type="date"
            value-format="yyyy-MM-dd"
            v-model="form.repairDate"
            :placeholder="$t('placeholder.select')"
          />
        </el-form-item>
        <!-- 严重程度 -->
        <el-form-item
          :label="$t('restockInfo.yzcd') + ':'"
          prop="severityLevel"
        >
          <el-select v-model="form.severityLevel" filterable clearable>
            <el-option
              v-for="(item, index) in severityData"
              :key="index"
              :label="item.label"
              :value="item.code"
            >
              <el-tooltip placement="right" effect="light">
                <div
                  slot="content"
                  class="severityTips"
                  v-html="item['desc' + $i18n.locale]"
                ></div>
                <span>{{ item.label }}</span>
              </el-tooltip>
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 是否重点问题 -->
        <el-form-item :label="$t('zlfk.sfzdwt') + ':'" prop="importantType">
          <el-radio-group v-model="form.importantType">
            <el-radio :label="1">{{ $t("seek.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("seek.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 重点问题描述 -->
        <el-form-item
          v-if="form.importantType === 1"
          :label="$t('zlfk.zdwtms') + ':'"
          prop="importantDescribe"
        >
          <el-input
            v-model="form.importantDescribe"
            :placeholder="$t('placeholder.enter')"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>
        <!-- 是否有维修措施 -->
        <el-form-item :label="$t('zlfk.sfywxcs') + ':'" prop="serviceMeasure">
          <el-radio-group v-model="form.serviceMeasure">
            <el-radio :label="1">{{ $t("seek.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("seek.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 市场维修措施 -->
        <el-form-item
          :label="$t('restockInfo.cswxcs') + ':'"
          prop="marketService"
          v-if="form.serviceMeasure == 1"
        >
          <el-input
            v-model="form.marketService"
            :placeholder="$t('placeholder.enter')"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <!-- 生产订单号 -->
        <el-form-item :label="$t('zlfk.scddh') + ':'" prop="orderNum">
          <el-input
            v-model="form.orderNum"
            :placeholder="$t('placeholder.enter')"
          />
        </el-form-item>
        <!-- 订单车辆数量 -->
        <el-form-item :label="$t('zlfk.ddclsl') + ':'" prop="carTotal">
          <el-input-number
            class="number-input"
            :controls="false"
            :precision="0"
            v-model="form.carTotal"
            :placeholder="$t('placeholder.enter')"
          >
          </el-input-number>
          <div class="number-input-append">{{ $t("zlfk.tai") }}</div>
        </el-form-item>
        <!-- 故障车数量 -->
        <el-form-item :label="$t('zlfk.gzcsl') + ':'" prop="badCarTotal">
          <el-input-number
            disabled
            class="number-input"
            :controls="false"
            :precision="0"
            v-model="form.badCarTotal"
            :placeholder="$t('placeholder.enter')"
          >
          </el-input-number>
          <div class="number-input-append">{{ $t("zlfk.tai") }}</div>
        </el-form-item>
        <!-- 故障车VIN码 -->
        <el-form-item :label="$t('zlfk.gzcvin') + ':'" prop="vinCheckRespList">
          <!-- 表格内容 -->
          <div class="table-container">
            <div class="table-btn">
              <!-- 添加 -->
              <el-button
                class="primary-btn"
                type="primary"
                icon="el-icon-plus"
                @click="handleAdd"
                >{{ $t("zlfk.tj") }}</el-button
              >
              <!-- 批量导入 -->
              <el-button
                class="primary-btn"
                icon="el-icon-upload2"
                plain
                @click="handleImport"
                >{{ $t("zlfk.pldr") }}</el-button
              >
            </div>
            <el-table
              ref="tableRef"
              stripe
              border
              highlight-current-row
              :data="form.vinCheckRespList"
              :cell-class-name="getRowColumn"
              @cell-click="tabClick"
              max-height="450px"
            >
              <!-- VIN码 -->
              <el-table-column
                property="vin"
                :label="$t('zlfk.vin')"
                min-width="180px"
                :render-header="$globalRenderHeader"
                align="center"
              >
                <template slot-scope="scope">
                  <el-input
                    ref="inputRef"
                    id="inputRef"
                    v-model="scope.row.vin"
                    :placeholder="$t('placeholder.enter')"
                    clearable
                    @blur="inputBlur"
                    @change="handleInput"
                  />
                </template>
              </el-table-column>
              <!-- 订单号 -->
              <el-table-column
                property="orderNum"
                :label="$t('cart.orderNumber')"
                min-width="120px"
                :render-header="$globalRenderHeader"
                align="center"
              >
                <template slot-scope="scope">
                  <el-input
                    @blur="orderInputBlur"
                    v-model="scope.row.orderNum"
                    :placeholder="$t('placeholder.enter')"
                  />
                </template>
              </el-table-column>
              <!-- 信息 -->
              <el-table-column
                :label="$t('zlfk.xx')"
                min-width="120px"
                :render-header="$globalRenderHeader"
                align="center"
              >
                <template slot-scope="scope">
                  <span
                    :style="
                      scope.row.messageZh === '成功'
                        ? 'color:#0EC98E'
                        : 'color:#ff0000'
                    "
                  >
                    {{
                      scope.row[
                        "message" +
                          $i18n.locale.charAt(0).toUpperCase() +
                          $i18n.locale.slice(1).toLowerCase()
                      ]
                    }}
                  </span>
                </template>
              </el-table-column>
              <!-- 生产日期 -->
              <el-table-column
                :label="$t('seek.produceDate')"
                width="160px"
                align="center"
                property="vinCreated"
                :render-header="$globalRenderHeader"
              >
                <template slot-scope="scope">
                  <el-date-picker
                    type="date"
                    value-format="yyyy-MM-dd"
                    v-model="scope.row.vinCreated"
                    :placeholder="$t('placeholder.select')"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <!-- 操作 -->
              <el-table-column
                :label="$t('cart.operate')"
                align="center"
                width="90px"
                :render-header="$globalRenderHeader"
              >
                <template slot-scope="scope">
                  <!-- 删除 -->
                  <el-button type="text" @click="handleDelete(scope.row)">{{
                    $t("cart.delete")
                  }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <!-- 零部件类别 -->
        <el-form-item :label="$t('zlfk.lztype') + ':'" prop="componentCategory">
          <el-select v-model="form.componentCategory" filterable clearable>
            <el-option
              v-for="(item, index) in componentCategoryList"
              :key="index"
              :label="item[componentCategoryName.get($i18n.locale)]"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 零部件批次信息 -->
        <el-form-item :label="$t('zlfk.lzpcinfo') + ':'" prop="componentBatchs">
          <el-input
            v-model="form.componentBatchs"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 发动机型号 -->
        <el-form-item
          :label="$t('seek.onlyEngine') + ':'"
          prop="engineModel"
          v-if="form.componentCategory == '1' || form.componentCategory == '2'"
        >
          <el-input
            v-model="form.engineModel"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 发动机号 -->
        <el-form-item
          :label="$t('seek.engineNUmber') + ':'"
          prop="engineNumber"
          v-if="form.componentCategory == '1' || form.componentCategory == '2'"
        >
          <el-input
            v-model="form.engineNumber"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 动力电池号 -->
        <el-form-item
          :label="$t('restockInfo.dldch') + ':'"
          prop="batteryNumber"
          v-if="form.componentCategory == '8'"
        >
          <el-input
            v-model="form.batteryNumber"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 电机号 -->
        <el-form-item
          :label="$t('climant.djNumer') + ':'"
          prop="motorNumber"
          v-if="form.componentCategory == '8'"
        >
          <el-input
            v-model="form.motorNumber"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 故障数量 -->
        <el-form-item :label="$t('zlfk.gznum') + ':'" prop="faultNumber">
          <el-input-number
            :controls="false"
            :precision="0"
            v-model="form.faultNumber"
            :placeholder="$t('home.placeholder')"
          >
          </el-input-number>
        </el-form-item>
        <!-- 疑似/祸首件代码 -->
        <el-form-item
          :label="$t('seek.culpritCode') + ':'"
          prop="suspectPartNumber"
        >
          <div class="searchFlex">
            <el-input
              v-model="form.suspectPartNumber"
              :placeholder="$t('placeholder.enter')"
            ></el-input>
            <el-button
              class="primary-btn"
              type="primary"
              @click="handlePartSearch"
              >{{ $t("home.query") }}</el-button
            >
          </div>
        </el-form-item>
        <!-- 疑似/祸首件名称 -->
        <el-form-item
          :label="$t('seek.culpritName') + ':'"
          prop="suspectPartName"
        >
          <el-input
            v-model="form.suspectPartName"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 供应商代码/名称 -->
        <!-- <el-form-item :label="$t('restockInfo.supplierInfo') + ':'" prop="supplierInfo">
          <el-input v-model="form.supplierInfo" :placeholder="$t('placeholder.enter')"></el-input>
        </el-form-item> -->
      </div>

      <!-- 问题描述 -->
      <div>
        <div class="titleTips">
          <img src="@/assets/image/wtmsIcon.png" alt="" />
          {{ $t("zlfk.wtms") }}
        </div>
        <!-- 故障描述 -->
        <el-form-item
          :label="$t('restockInfo.gzxxms') + ':'"
          prop="questionContent"
        >
          <el-input
            v-model="form.questionContent"
            type="textarea"
            :placeholder="$t('placeholder.enter')"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>
        <!-- 重复性 -->
        <el-form-item :label="$t('restockInfo.cfx') + ':'" prop="repeatability">
          <el-radio-group v-model="form.repeatability">
            <el-radio :label="0">{{ $t("restockInfo.exist") }}</el-radio>
            <el-radio :label="1">{{ $t("restockInfo.occasional") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 附件 -->
        <!-- <el-form-item :label="$t('zlfk.fj') + ':'" prop="faultCommonFiles">
          <drag-upload ref="uploadFile" :accessoryList.sync="form.faultCommonFiles"
            :httpRequest="action" />
        </el-form-item> -->
      </div>
      <!-- 图片和视频 -->
      <div>
        <div class="titleTips">
          <img src="@/assets/image/ImgIcon.png" alt="" />
          {{ $t("restockInfo.imgVideo") }}
        </div>
        <fileUploadTips></fileUploadTips>
        <!-- 是否有故障视频/图片 -->
        <el-form-item :label="$t('restockInfo.gzfj') + ':'" prop="faultVideo">
          <el-radio-group v-model="form.faultVideo">
            <el-radio :label="1">{{ $t("seek.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("seek.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="$t('zlfk.fj') + ':'"
          prop="faultVideoFiles"
          v-if="form.faultVideo == 1"
        >
          <drag-upload
            ref="uploadFile"
            :accessoryList.sync="form.faultVideoFiles"
            :tipStatus="false"
            :httpRequest="action"
          />
        </el-form-item>
        <!-- 是否有故障代码 -->
        <el-form-item :label="$t('restockInfo.gzdm') + ':'" prop="faultCode">
          <el-radio-group v-model="form.faultCode">
            <el-radio :label="1">{{ $t("seek.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("seek.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="$t('cart.remark') + ':'"
          prop="faultCodeRemark"
          v-if="form.faultCode == 1"
        >
          <el-input
            v-model="form.faultCodeRemark"
            :placeholder="$t('placeholder.enter')"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('zlfk.fj') + ':'"
          prop="faultCodeFiles"
          v-if="form.faultCode == 1"
        >
          <drag-upload
            ref="uploadFile"
            :accessoryList.sync="form.faultCodeFiles"
            :tipStatus="false"
            :httpRequest="action"
          />
        </el-form-item>
        <!-- 是否有其他说明 -->
        <el-form-item
          :label="$t('restockInfo.qtsm') + ':'"
          prop="otherInstructions"
        >
          <el-radio-group v-model="form.otherInstructions">
            <el-radio :label="1">{{ $t("seek.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("seek.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="$t('cart.remark') + ':'"
          prop="otherRemark"
          v-if="form.otherInstructions == 1"
        >
          <el-input
            v-model="form.otherRemark"
            :placeholder="$t('placeholder.enter')"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('zlfk.fj') + ':'"
          prop="otherFiles"
          v-if="form.otherInstructions == 1"
        >
          <drag-upload
            ref="uploadFile"
            :accessoryList.sync="form.otherFiles"
            :tipStatus="false"
            :httpRequest="action"
          />
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="text-center">
      <el-button
        class="primary-btn lang-but"
        type="primary"
        @click="handleSave"
      >
        {{ $t("seek.submit") }}
      </el-button>
      <el-button
        class="primary-btn lang-but"
        plain
        @click="dialogVisible = false"
        >{{ $t("seek.cancel") }}</el-button
      >
    </div>
    <import-model-dialog
      ref="importModelDialog"
      :uploadUrl="uploadUrl"
      :templateUrl="templateUrl[$i18n.locale]"
      @success="getList"
    />
  </el-dialog>
</template>

<script>
import {
  preProblemAddApi,
  preProblemEditApi,
  checkModelApi,
  getVehicleAmountByOrderNumber,
} from "@/api/feedback";
import ImportModelDialog from "@/components/importModelDialog.vue";
import { uploadUrl } from "@/util/url";
import fileUploadTips from "@/components/fileUpload/fileUploadTips";
import faultData from "@/mixins/faultData";
import { getModel } from "@/api/seek";
export default {
  mixins: [faultData],
  components: { ImportModelDialog, fileUploadTips },
  props: {
    carTypeList: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {
      action: "/customer/claim/upload",
      modalVin: "", // 带出车型的vin
      title: "", // 弹窗标题
      dialogVisible: false, // 弹窗显示
      form: this.getForm(), // 表单数据
      tabRowIndex: "", // 点击表格行索引
      tabColumnIndex: "", // 点击表格列索引
      uploadUrl: uploadUrl + "/customer/car/feedback/importVin", // 导入地址
      templateUrl: {
        zh: "https://shineray-dev-oversea.oss-cn-chengdu.aliyuncs.com/dev/excel/claim-excel/2024/11/06/d222388533a6475c8ca9cb5ad77417b2.xlsx",
        en: "https://shineray-dev-oversea.oss-cn-chengdu.aliyuncs.com/dev/excel/claim-excel/2024/11/06/1103c38bb54a41f4937489c8890608ea.xlsx",
        ru: "https://shineray-dev-oversea.oss-cn-chengdu.aliyuncs.com/dev/excel/claim-excel/2024/11/06/60f9cb49d5b24ed7ae2e12316a825ae2.xlsx",
        fa: "https://shineray-dev-oversea.oss-cn-chengdu.aliyuncs.com/dev/excel/claim-excel/2024/11/06/a2229cf1ee7941f8a7fb0842b5e457c7.xlsx",
      },
    };
  },
  computed: {
    labelWidth() {
      const widthMap = {
        zh: "160px",
        ru: "370px",
        en: "320px",
        vi: "260px",
        es: "295px",
      };
      return widthMap[this.$i18n.locale] || "200px";
    },
    recordLabelWidth() {
      const widthMap = {
        zh: "85px",
        en: "180px",
        es: "240px",
        ru: "330px",
      };
      return widthMap[this.$i18n.locale] || "165px";
    },
    // 表单验证规则
    formRules() {
      // 公共规则配置
      const commonRule = {
        required: true,
        trigger: ["change", "blur"],
        message: this.$t("restockInfo.nullTip"),
      };
      return {
        ...Object.fromEntries(
          [
            "carModel",
            "carAttribute",
            "happenDate",
            "repairDate",
            "severityLevel",
            "importantType",
            "importantDescribe",
            "serviceMeasure",
            "marketService",
            "orderNum",
            "carTotal",
            "vinCheckRespList",
            "componentCategory",
            "engineModel",
            "engineNumber",
            "faultNumber",
            "questionContent",
            "repeatability",
            "faultVideo",
            "faultVideoFiles",
            "faultCode",
            "faultCodeRemark",
            "otherInstructions",
            "otherRemark",
          ].map((field) => [field, commonRule])
        ),
      };
    },
  },
  created() {},
  methods: {
    // 初始化
    async init(title, data = {}) {
      this.title = title;
      this.dialogVisible = true;
      this.form = this.getForm(data);
      this.form.vinCheckRespList.map((item, index) => {
        this.form.vinCheckRespList[index].messageZh = "成功";
        this.form.vinCheckRespList[index].messageEn = "success";
        this.form.vinCheckRespList[index].messageRu = "Успех";
        this.form.vinCheckRespList[index].messageFa = "موفقیت";
        this.form.vinCheckRespList[index].messageEs = "éxito";
        this.form.vinCheckRespList[index].messageVi = "thành công";
      });
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    // 获取表单对象
    getForm(data = {}) {
      return {
        carModel: data.carModel || "",
        carAttribute: data.carAttribute,
        happenDate: data.happenDate || "",
        happenPlace: data.happenPlace || "",
        repairDate: data.repairDate || "",
        severityLevel: data.severityLevel || "",
        importantType: data.importantType ?? 1,
        importantDescribe: data.importantDescribe || "",
        serviceMeasure: data.serviceMeasure ?? 1,
        marketService: data.marketService || "",
        nowTaskId: data.nowTaskId || "",
        orderNum: data.orderNum || "",
        carTotal: data.carTotal || undefined,
        badCarTotal: data.badCarTotal || undefined,
        vinCheckRespList: data.vinCheckRespList
          ? JSON.parse(JSON.stringify(data.vinCheckRespList))
          : [],
        componentCategory: Number(data.componentCategory) || "",
        componentBatchs: data.componentBatchs || "",
        engineModel: data.engineModel || "",
        engineNumber: data.engineNumber || "",
        batteryNumber: data.batteryNumber || "",
        motorNumber: data.motorNumber || "",
        faultNumber: data.faultNumber || undefined,
        suspectPartName: data.suspectPartName || "",
        suspectPartNumber: data.suspectPartNumber || "",
        supplierInfo: data.supplierInfo || "",
        questionContent: data.questionContent || "",
        repeatability: data.repeatability || 0,
        faultCommonFiles: this.convertArrayData(data.faultCommonFiles),

        feedbackFormId: data.feedbackFormId || "",
        questionId: data.questionId || "",

        delList: [], // 删除vin列表记录

        orderNumber: data.orderNumber || "",
        orderQuantity: data.orderQuantity || "",

        submit: data.status === 3 ? true : false,
        status: data.status || 0,
        faultVideo: data.faultVideo ?? 1,
        faultVideoFiles: this.convertArrayData(data.faultVideoFiles),
        faultCode: data.faultCode ?? 1,
        faultCodeRemark: data.faultCodeRemark || "",
        faultCodeFiles: this.convertArrayData(data.faultCodeFiles),
        otherInstructions: data.otherInstructions ?? 1,
        otherRemark: data.otherRemark || "",
        otherFiles: this.convertArrayData(data.otherFiles),
      };
    },
    // 添加故障车vin码
    handleAdd() {
      this.$loading.hide();
      this.form.vinCheckRespList.unshift({});
      this.tabRowIndex = 0;
      this.tabColumnIndex = 0;
      this.$nextTick(() => {
        document.getElementById("inputRef").focus();
      });
    },
    // 删除故障车vin码
    handleDelete({ index, id }) {
      this.form.delList.push({ id: id });
      this.form.vinCheckRespList.splice(index, 1);
      this.getVinRelevantInfo();

      // id && this.form.delList.push({ id: id });
    },
    // 批量导入故障车vin码
    handleImport() {
      this.$refs.importModelDialog.init(this.$t("zlfk.pldr"));
    },
    // 导入成功列表
    getList(data) {
      if (data.length > 0) {
        data.map((item, index) => {
          data[index].showOrderNumInput =
            !item.orderNum && item.messageZh === "成功";
        });
      }

      var allVinList = [...this.form.vinCheckRespList, ...data];
      this.form.vinCheckRespList = allVinList.filter(
        (item, index, arr) =>
          arr.findIndex((obj) => obj.vin === item.vin) === index
      );
      this.getVinRelevantInfo();
    },
    // 把角标赋值给行和列
    getRowColumn({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;
    },
    // 单元格点击编辑数据
    tabClick(row, column, cell, event) {
      if (column.property === "vin") {
        this.tabRowIndex = row.index;
        this.tabColumnIndex = column.index;
        this.$nextTick(() => {
          document.getElementById("inputRef").focus();
        });
      }
    },
    // 失去光标
    async inputBlur() {
      setTimeout(async () => {
        // 获取故障车VIN码信息
        const res = await checkModelApi({
          data: {
            vinCheckRespList: [
              { vin: this.form.vinCheckRespList[this.tabRowIndex].vin },
            ],
          },
        });
        delete res.data[0].id;
        this.$set(this.form.vinCheckRespList, this.tabRowIndex, {
          ...this.form.vinCheckRespList[this.tabRowIndex],
          ...res.data[0],
          showOrderNumInput:
            !res.data[0].orderNum && res.data[0].messageZh === "成功",
        });
        this.form.vinCheckRespList = this.form.vinCheckRespList.filter(
          (item, index, arr) =>
            arr.findIndex((obj) => obj.vin === item.vin) === index
        );

        this.tabRowIndex = "";
        this.tabColumnIndex = "";
        this.getVinRelevantInfo();
      });
    },
    // 输入VIN码
    handleInput() {
      document.getElementById("inputRef").blur(); // 取消焦点
    },
    // 获取vin列表
    async getVinList() {
      if (this.form.vinCheckRespList.length !== 0) {
        const res = await checkModelApi({
          data: {
            vinCheckRespList: this.form.vinCheckRespList,
          },
        });
        this.form.vinCheckRespList = res.data;
      }
    },
    async getVinRelevantInfo() {
      var vinList = this.form.vinCheckRespList;
      if (vinList.length > 0) {
        // 车型
        this.getModelData(vinList);
        this.form.badCarTotal = vinList.length;
        // 订单号
        this.getOrderData(vinList);
        // 订单车辆数量
        if (this.form.orderNum) {
          const res = await getVehicleAmountByOrderNumber(this.form.orderNum);
          if (res.status == 0) {
            this.form.carTotal = res.data || "0";
          } else {
            this.form.carTotal = this.form.carTotal || "0";
          }
        }
      } else {
        this.form.carModel = "";
        this.form.orderNum = "";
        this.form.carTotal = "0";
        this.form.badCarTotal = "0";
      }
    },
    getModelData(vinList) {
      var modelList = [
        ...new Set(vinList.map((item) => item.carModel).filter(Boolean)),
      ].join(",");
      if (modelList) {
        this.form.carModel = modelList;
      } else {
        this.form.carModel = this.form.carModel;
      }
    },
    getOrderData(vinList) {
      var orderList = [
        ...new Set(vinList.map((item) => item.orderNum).filter(Boolean)),
      ].join(",");
      if (orderList) {
        this.form.orderNum = orderList;
      } else {
        this.form.orderNum = this.form.orderNum;
      }
    },
    orderInputBlur() {
      var vinList = this.form.vinCheckRespList;
      this.getOrderData(vinList);
    },
    // 获取疑似/祸首件名称
    async handlePartSearch() {
      this.getCheckPart();
    },
    // 获取提示信息
    getRequiredTips(object) {
      const propLabelMap = {
        carModel: "home.carType",
        carAttribute: "zlfk.clsx",
        happenDate: "zlfk.gzfsrq",
        repairDate: "seek.warrantyDate",
        severityLevel: "restockInfo.yzcd",
        importantType: "zlfk.sfzdwt",
        importantDescribe: "zlfk.zdwtms",
        serviceMeasure: "zlfk.sfywxcs",
        marketService: "restockInfo.cswxcs",
        vinCheckRespList: "zlfk.gzcvin",
        componentCategory: "zlfk.lztype",
        engineModel: "seek.onlyEngine",
        engineNumber: "seek.engineNUmber",
        faultNumber: "zlfk.gznum",
        questionContent: "restockInfo.gzxxms",
        repeatability: "restockInfo.cfx",
        faultVideo: "restockInfo.gzfj",
        faultVideoFiles: "zlfk.fj",
        faultCode: "restockInfo.gzdm",
        faultCodeRemark: "cart.remark",
        otherInstructions: "restockInfo.qtsm",
        otherRemark: "cart.remark",
      };
      let errorLabels = [];
      if (object) {
        Object.keys(object).forEach((prop) => {
          let label = "";
          if (prop === "faultVideoFiles") {
            label = `${this.$t("restockInfo.gzTitle")}-${this.$t("zlfk.fj")}`;
          } else if (prop === "faultCodeRemark") {
            label = `${this.$t("restockInfo.gzcode")}-${this.$t(
              "cart.remark"
            )}`;
          } else if (prop === "otherRemark") {
            label = `${this.$t("restockInfo.otherInfo")}-${this.$t(
              "cart.remark"
            )}`;
          } else if (
            prop.startsWith("vinCheckRespList[") &&
            prop.endsWith(".orderNum")
          ) {
            label = this.$t("cart.orderNumber");
          } else if (propLabelMap[prop]) {
            label = this.$t(propLabelMap[prop]);
          }
          if (label && !errorLabels.includes(label)) {
            errorLabels.push(label);
          }
        });
      }
      if (errorLabels.length > 0) {
        this.$DonMessage.warning(`${errorLabels.join(", ")}`);
      } else {
        this.$DonMessage.warning(this.$t("restockInfo.required"));
      }
    },
    // 保存
    handleSave() {
      this.$refs.form.validate(async (valid, object) => {
        if (!this.getFileUploadTip()) {
          return;
        }
        if (!valid) {
          this.getErrorLocation();
          this.getRequiredTips(object);
          return;
        }

        try {
          const submitData = this.getFeedbackDetail();
          let res = {};
          if (submitData.questionId) {
            res = await preProblemEditApi({ data: submitData });
          } else {
            res = await preProblemAddApi({ data: submitData });
          }
          if (res.status == 0) {
            this.dialogVisible = false;
            this.$DonMessage.success(this.$t("message.czcg"));
            this.$emit("success", res.data);
            this.dialogVisible = false;
          } else {
            this.$DonMessage.error(res.message);
          }
        } catch (error) {
          console.error(error);
        }
      });
    },
  },
  mounted() {
    this.getTypeList();
  },
};
</script>
